import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import {
  Card,
  CardActions,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { FunctionComponent } from 'react';

import { UsersQuery } from '../../apollo/__generated__/graphql';
import { Dialog } from '../../components/Dialog';
import { Tooltip } from '../../components/Tooltip';
import { Layout } from '../../navigation/components/Layout/Layout';
import { AddRoleDialog } from './components/AddRoleDialog/AddRoleDialog';
import { useAdminUsers } from './useAdminUsers';

export const AdminUsers: FunctionComponent = () => {
  const {
    users,
    loading,
    dialog,
    onCloseDialog,
    onRemoveRole,
    onAddRole,
    addRoleUserId,
    onCloseAddRoleDialog,
    clearSearch,
    onSearchChange,
    search,
  } = useAdminUsers();

  const columns: GridColDef<UsersQuery['users'][number]>[] = [
    { field: 'firstname', headerName: 'Prénom' },
    { field: 'lastname', headerName: 'Nom' },
    { field: 'email', headerName: 'Email', width: 250 },
    {
      field: 'role',
      headerName: 'Roles',
      width: 350,
      renderCell: (params) => (
        <>
          {params.row.roles.map((role) => (
            <Tooltip
              key={role.name}
              title={
                role.givenByUser
                  ? `Donné par ${role.givenByUser.firstname} ${role.givenByUser.lastname} (${role.givenByUser.email})`
                  : ''
              }
            >
              <Chip
                label={role.name}
                variant="outlined"
                onDelete={() => onRemoveRole(params.row.id, role.name)}
              />
            </Tooltip>
          ))}
          <Tooltip title="Ajouter un rôle">
            <IconButton onClick={() => onAddRole(params.row.id)}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <Layout title="Administration - Utilisateurs" activeTab="adminUsers">
      <Card sx={{ mb: 2 }}>
        <CardActions>
          <TextField
            label="Rechercher un utilisateur"
            size="small"
            value={search}
            onChange={onSearchChange}
            InputProps={{
              startAdornment: <SearchIcon />,
              endAdornment:
                search.length > 0 ? (
                  <InputAdornment position="end">
                    <IconButton onClick={clearSearch} onMouseDown={clearSearch}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : undefined,
            }}
          />
        </CardActions>
      </Card>

      <DataGrid
        rows={users}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        loading={loading}
      />
      {dialog ? (
        <Dialog
          title={dialog.title}
          description={dialog.description}
          onSubmit={dialog.onSubmit}
          onCancel={onCloseDialog}
          open
        />
      ) : null}
      {addRoleUserId ? (
        <AddRoleDialog
          open
          onClose={onCloseAddRoleDialog}
          userId={addRoleUserId}
        />
      ) : null}
    </Layout>
  );
};
